import { Link, useLocation } from 'react-router-dom';
import { categoryNames } from '@/mocks/categories';

interface Crumb {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const crumbs: Crumb[] = [{ label: '首页', href: '/' }];

  if (pathParts[0] === 'category') {
    const slug = pathParts[1];
    crumbs.push({ label: '分类' });
    if (slug && categoryNames[slug]) {
      crumbs.push({ label: categoryNames[slug] });
    }
  } else if (pathParts[0] === 'article') {
    crumbs.push({ label: '视频详情' });
  } else if (pathParts[0] === 'about') {
    crumbs.push({ label: '关于我们' });
  }

  if (crumbs.length <= 1) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: crumb.label,
      item: crumb.href ? `https://www.kuaimao.com${crumb.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center gap-1 text-sm text-foreground-500 flex-wrap">
          {crumbs.map((crumb, i) => (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>}
              {crumb.href ? (
                <Link to={crumb.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-700">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}